var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalVolumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_4255_14275)",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_14275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.6641,
    y: 24,
    width: 3,
    height: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.6641,
    y: 29,
    width: 3,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.6641,
    y: 22,
    width: 3,
    height: 23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6641,
    y: 18,
    width: 3,
    height: 27,
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4255_14275",
    x1: 9,
    y1: 2,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_14275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVolumn);
export default __webpack_public_path__ + "static/media/totalVolumn.c2af304415c50cf7391fc71a806638dc.svg";
export { ForwardRef as ReactComponent };